import _                                              from 'underscore';
import React, { FC, useContext, useEffect, useState } from 'react';
import { ProjectContext }                             from './ProjectIndexPage';
import { LDFlagSet, useLDClient }                     from 'launchdarkly-react-client-sdk';

import { runIfFunction }                                                   from '@src/util';
import { useCurrentUser }                                                  from '@src/hooks';
import { ENVIRONMENT_IS_DEVELOPMENT, ORGANIZATIONAL_ROLES, PROJECT_ROLES } from '@src/constants';


interface Props {

    // Callback method once id / new feature flags acquired
    onLDIdentified?: () => void
}

const defaultProps: Props = {

    onLDIdentified: () => {}
}

const LaunchDarklyIdentifier: FC<Props> = ( props ) => {

    let LDClient                                 = useLDClient(),
        { projectId, organizationId }            = useContext( ProjectContext ),
        { currentUser, getLDUserIdentification } = useCurrentUser(),
        [ IDBlock, setIDBlock ]                  = useState( null );

    // When settings request changes...
    useEffect( () => {

        handleApplyNewIdentity()

    } );

    // When config gets updated...
    useEffect( () => {

        runIfFunction( props.onLDIdentified, IDBlock );

    }, [ IDBlock ] );

    const handleApplyNewIdentity = async () => {

        if( currentUser && !IDBlock ){

            // Get current project and org
            let currentProject      = _.findWhere( currentUser.projects, { projectId } ),
                currentOrganization = _.findWhere( currentUser.organizations, { organizationId } );

            let newUserInfo = getLDUserIdentification( {
                projectId:        currentProject?.projectId ?? null,
                projectRole:      currentProject?.projectRole as unknown as PROJECT_ROLES ?? null,
                organizationId:   currentOrganization?.organizationId ?? null,
                organizationRole: currentOrganization?.organizationRole as unknown as ORGANIZATIONAL_ROLES ?? null,
            } );

            // Remove null fields
            newUserInfo = _.omit( newUserInfo, ( value, key, object ) => _.isNull( value ) );

            // Set new LD identity
            try{

                await LDClient?.identify( newUserInfo, null, ( err: Error, flags: LDFlagSet ) => {


                    setIDBlock( newUserInfo );

                    if( ENVIRONMENT_IS_DEVELOPMENT ){

                        console.table( newUserInfo.custom );
                        console.warn( '[ LDClient ] identifier called successfully.' );
                    }

                } );

            } catch( e ) {


                if( ENVIRONMENT_IS_DEVELOPMENT ){

                    console.log( e );
                    console.warn( '[ LDClient ] unable to be identified.' );
                    console.warn( '[ LDClient ] user info prepped: %o', newUserInfo );
                }
            }

        }
    }

    // When we have a config, continue on
    return ( currentUser && IDBlock ) ? <>{ props.children }</> : <React.Fragment/>;
};

LaunchDarklyIdentifier.defaultProps = defaultProps;

export { LaunchDarklyIdentifier }
